import { AppStateFailure, IStateSlice } from '@symphony-solo/shared/common-state/src';
import { AccountDetails, ChangePassword, EmailDomains, PersonalDetails, SoftCheckResponse, TokenResult } from '../models';
import { AccountCreate, AccountProperties } from '../models/account.model';

export class AuthenticationState implements IStateSlice {
  public isLoading: boolean;
  public failures: AppStateFailure;
  public authToken: TokenResult;
  public locationToken: TokenResult;
  public email: string;
  public accountDetails: AccountDetails;
  public softCheckResponse: SoftCheckResponse;
  public sendResetPasswordRequest: boolean;
  public createAccountRequest: AccountCreate;
  public accountProperties: AccountProperties;
  public personalDetails: PersonalDetails;
  public personalDetailsSuccess: Object;
  public changePasswordSuccess: Object;
  public emailDomains: EmailDomains;
  public changePassword: ChangePassword;
  public deactivateAccount: Object;

  constructor() {
    this.isLoading = false;
    this.failures = null;
    this.authToken = null;
    this.accountDetails = null;
    this.locationToken = null;
    this.softCheckResponse = null;
    this.sendResetPasswordRequest = false;
    this.createAccountRequest = null;
    this.accountProperties = null;
    this.personalDetails = null;
    this.personalDetailsSuccess = null;
    this.emailDomains = null;
    this.changePassword = null;
    this.changePasswordSuccess = null;
    this.deactivateAccount = null;
  }
}
